import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Signal,
  computed,
  input,
} from '@angular/core';
import { HicapsConnectService } from '@principle-theorem/ng-payments';
import { GlobalStoreService } from '@principle-theorem/ng-principle-shared';
import { ObservableDataSource } from '@principle-theorem/ng-shared';
import { Practice } from '@principle-theorem/principle-core';
import {
  IHicapsConnectTerminal,
  IPractice,
} from '@principle-theorem/principle-core/interfaces';
import { doc$, HISTORY_DATE_FORMAT, WithRef } from '@principle-theorem/shared';
import { Observable, ReplaySubject } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Component({
  selector: 'pr-practice-hicaps-connect-terminals',
  templateUrl: './practice-hicaps-connect-terminals.component.html',
  styleUrls: ['./practice-hicaps-connect-terminals.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PracticeHicapsConnectTerminalsComponent {
  private readonly _baseDisplayedColumns: string[] = [
    'name',
    'merchantId',
    'terminalId',
    'practitioner',
    'bridgeDevice',
    'lastActive',
  ];

  readonly dateFormat = HISTORY_DATE_FORMAT;
  practice$ = new ReplaySubject<WithRef<IPractice>>(1);
  terminals$: Observable<WithRef<IHicapsConnectTerminal>[]>;
  dataSource: ObservableDataSource<WithRef<IHicapsConnectTerminal>>;

  readonly readOnly = input(false);

  readonly displayedColumns: Signal<string[]> = computed(() =>
    this.readOnly()
      ? this._baseDisplayedColumns
      : [...this._baseDisplayedColumns, 'actions']
  );

  @Input()
  set practice(practice: WithRef<IPractice>) {
    if (practice) {
      this.practice$.next(practice);
    }
  }

  constructor(
    public hicapsConnect: HicapsConnectService,
    public globalStore: GlobalStoreService
  ) {
    this.terminals$ = this.practice$.pipe(
      switchMap((practice) => Practice.hicapsConnectTerminals$(practice))
    );
    this.dataSource = new ObservableDataSource(this.terminals$);
  }

  bridgeDeviceName$(
    terminal: WithRef<IHicapsConnectTerminal>
  ): Observable<string> {
    return doc$(terminal.bridgeDevice).pipe(
      map((bridgeDevice) => bridgeDevice.name)
    );
  }
}
